import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import archives from '@/components/archives'
import tags from '@/components/tags'
import links from '@/components/links'
import about from '@/components/about'

import noteItem from '@/components/module/noteItem'
import noteList from '@/components/module/noteList'
// import page01A from '@/components/page01/page01-A'
// import page01B from '@/components/page01/page01-b'
// import pageEnd from '@/components/page01/B/end'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/archives',
      name: 'archives',
      component: archives,
     /* children: [
        {
          path: 'page01-a',
          name: 'page01A',
          component: page01A
        },
        {
          path: 'page01-b',
          name: 'page01B',
          component: page01B,
          children: [
            {
              path: 'end',
              name: 'pageEnd',
              component: pageEnd
            }
          ]
        }
      ]*/
    },
    {
      path: '/tags',
      name: 'tags',
      component: tags
    },
    {
      path: '/links',
      name: 'links',
      component: links
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/noteItem',
      name: 'noteItem',
      component: noteItem
    },
    {
      path: '/noteList',
      name: 'noteList',
      component: noteList
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js